import React from 'react';
import { YoYBadge } from '../../components';
import type { Column } from '../../components';
import type { HeaderGroup } from '../../components/RankedTable';
import type { GroupBy, Period, RegionRow } from '../../api/types';
import { formatInt } from '../../utils/format';
import { periodGroups, salesColumns } from '../periodColumns';

const yoyCell = (v: number | null | undefined) => <YoYBadge value={v ?? null} variant="inline" showArrow={false} />;

/** Columns of the State / City performance table: Rank, name, stores, then Sales + YoY per period. Shared by Home and State Wise. */
export function regionColumns(
  groupBy: GroupBy,
  shownPeriod: Period,
  comparePeriod: Period | null | undefined,
): { columns: Column<RegionRow>[]; groups?: HeaderGroup[] } {
  const lead: Column<RegionRow>[] = [
    { key: 'rank', header: '#', width: 22, render: (r) => r.rank },
    { key: 'name', header: groupBy === 'state' ? 'State' : 'City', render: (r) => (groupBy === 'state' ? r.state : r.key) },
    { key: 'stores', header: 'Stores', align: 'right', width: 40, render: (r) => formatInt(r.store_count) },
  ];
  if (comparePeriod) {
    const dual = periodGroups<RegionRow>(
      shownPeriod, comparePeriod,
      { sales: (r) => r.sales, yoy: (r) => r.yoy_pct },
      { sales: (r) => r.compare_sales, yoy: (r) => r.compare_yoy_pct },
      56, 48, yoyCell,
    );
    return { columns: [...lead, ...dual.columns], groups: dual.groups };
  }
  return {
    columns: [
      ...lead,
      ...salesColumns<RegionRow>(shownPeriod, null, (r) => r.sales, () => null, 66),
      { key: 'yoy', header: 'YoY %', align: 'right', width: 56, render: (r) => yoyCell(r.yoy_pct) },
    ],
  };
}
